import { render, staticRenderFns } from "./kpi2.vue?vue&type=template&id=afc90594&scoped=true&"
import script from "./kpi2.vue?vue&type=script&lang=js&"
export * from "./kpi2.vue?vue&type=script&lang=js&"
import style0 from "./kpi2.vue?vue&type=style&index=0&id=afc90594&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc90594",
  null
  
)

export default component.exports